<mat-toolbar class="header-content">
    <div class="header-title">
        <mat-icon>edit</mat-icon>
        {{ 'menu.devices.configs.edit_selection' | translate }} ({{ configs.length }})
    </div>

    <lib-button icon="close" color="none" textColor="muted" (click)="cancel()"
        tooltip="{{'viewer.close'|translate}}"></lib-button>
</mat-toolbar>

<mat-dialog-content>
    <p class="bulk-warning">{{ 'menu.devices.configs.bulk_edit_warning' | translate }}</p>

    <app-tracker-config-form [config]="configDraft" [lockType]="type" [hideName]="true" [hideSaveAsTemplate]="true"
        (save)="save()" (cancelForm)="cancel()"></app-tracker-config-form>
</mat-dialog-content>
